import iconsPlugin from "@/plugins/iconsPlugin.js";


export default function installPlugins(app){
    app.use(iconsPlugin)
}